/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_7e9e623b"]'><div :class='["dialog-right-angle-passenger-demo"]'><cube-button @_click="onClickDialog">Dialog - show-slot-with-right-angle</cube-button><cube-dialog ref="__mpx_ref_dialogWithRightAngle__" type="alert" :class='["dialog-right-angle"]'><div slot="title" :class='["dialog-show-slot-title","right-angle-slot-title"]'><mpx-image mode="aspectFit" src="" :class='["show-slot-img"]'></mpx-image></div><div slot="content" :class='["dialog-show-slot-content"]'><div :class='["right-angle-title"]'>主标题控制在十二字符内</div><div :class='["right-angle-content"]'>这里是内容部分，应该控制在十八字符内</div><div @tap='(e)=>__invoke(e, [["onCloseDialog"]])' :class='["right-angle-btn"]'>五个字符内</div><div :class='["right-angle-footer-logo"]'><mpx-image src="https://dpubstatic.udache.com/static/dpubimg/9b1211da-56b4-41c1-8182-b45a2b198638.png" mode="aspectFit" :class='["logo-img"]'></mpx-image><div :class='["logo-text"]'>滴滴出行</div></div></div></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_7e9e623b"}'>
.dialog-right-angle .cube-dialog-main
  border-radius 0

.right-angle-slot-title
  margin 4px
  background-color #eeeeee
  opacity .48
.right-angle-title,
.right-angle-content
  font-family PingFangSC-Medium
  font-size 16px
  color #333
  letter-spacing 0
  text-align center
.right-angle-content
  font-family PingFangSC-Regular
  font-size 12px
  color #666
.right-angle-btn
  width 103px
  height 24px
  border .5px solid #ea5e1e
  border-radius 24px 24px
  margin 13px auto 18px
  font-family PingFangSC-Regular
  font-size 12px
  color #EA5E1E
  background-color #fff
  letter-spacing 0
  text-align center
  line-height 24px

.dialog-right-angle .cube-dialog-content
  margin-bottom 0
.right-angle-footer-logo
  display flex
  justify-content center
  align-items center
  border-top .5px solid #eaeaea
  padding 12px 10px
  box-sizing border-box
.logo-img
  width 15px
  height 12px
.logo-text
  height 10px
  line-height 10px
  margin-left 2px
  color #5a5a5a
  font-size 10px
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_7e9e623b"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_7e9e623b"}
  /** script content **/
  require("./dialog-show-slot-with-right-angle.mpx.js?isComponent&outputPath=components%2Fdialog-show-slot-with-right-angle7e9e623b%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-show-slot-with-right-angle.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-show-slot-with-right-angle7e9e623b%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_7e9e623b"],
    ctorType: "component",
    outputPath: "components/dialog-show-slot-with-right-angle7e9e623b/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image?isComponent"), {__mpxBuiltIn: true})},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>